// src/store/slices/roleSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    roles: [],
    selectedRole: null,
    loading: false,
    error: null,
    searchResults: [],
    lastUpdated: null
};

const roleSlice = createSlice({
    name: 'role',
    initialState,
    reducers: {
        rolesLoaded(state, action) {
            state.roles = action.payload.roles;
            state.lastUpdated = new Date().toISOString();
            state.loading = false;
            state.error = null;
        },

        roleSelected(state, action) {
            state.selectedRole = action.payload.role;
        },

        loadingStarted(state) {
            state.loading = true;
            state.error = null;
        },

        loadingFailed(state, action) {
            state.loading = false;
            state.error = action.payload.error;
        },

        loadingStopped(state) {
            state.loading = false;
        },

        reset() {
            return initialState;
        }
    }
});

export const roleActions = roleSlice.actions;
export const roleReducer = roleSlice.reducer;